export const fuseSupervisorNavigationConfig = [
        {
            'id': 'application',
            'title': 'Applications',
            'type': 'group',
            'icon': 'apps',
            'children': [
                {
                    'id': 'dashboard',
                    'title': 'Dashboard',
                    'type': 'item',
                    'icon': 'dashboard',
                    'url': '/apps/dashboards/admin'
                },
            ]
        },
        {
            'id': 'system',
            'title': 'System',
            'type': 'collapse',
            'icon': 'settings',
            'children': [
                {
                    'id': 'unit-category',
                    'title': 'Units Category',
                    'type': 'item',
                    'url': '/system/unit-category'
                },
                {
                    'id': 'unit-type',
                    'title': 'Unit Types',
                    'type': 'item',
                    'url': '/system/unit-type'
                },
                {
                    'id': 'unit-conversion',
                    'title': 'Units & Conversion',
                    'type': 'item',
                    'url': '/system/unit-conversion'
                }
            ]
        },
        {
            'id': 'sales',
            'title': 'Sales',
            'type': 'collapse',
            'icon': 'assessment',
            'children': [
                {
                    'id': 'invoice',
                    'title': 'Invoice',
                    'type': 'item',
                    'url': '/sales/billing'
                },
                {
                    'id': 'invoice',
                    'title': 'Invoice View',
                    'type': 'item',
                    'url': '/sales/invoice'
                },
                {
                    'id': 'broker',
                    'title': 'Broker',
                    'type': 'item',
                    'url': '/sales/broker'
                },
                {
                    'id': 'receipt',
                    'title': 'Receipt',
                    'type': 'item',
                    'url': '/sales/receipt'
                },
                {
                    'id': 'receiptView',
                    'title': 'Receipt View',
                    'type': 'item',
                    'url': '/sales/receiptView'
                },
                {
                    'id': 'deliveryOrder',
                    'title': 'Delivery Note',
                    'type': 'item',
                    'url': '/sales/deliveryNote'
                },
                {
                    'id': 'deliveryOrderView',
                    'title': 'Delivery Note View',
                    'type': 'item',
                    'url': '/sales/deliveryNoteView'
                }
            ]
        },
        {
            'id': 'crm',
            'title': 'CRM',
            'type': 'collapse',
            'icon': 'contacts',
            'children': [
                {
                    'id': 'customerList',
                    'title': 'Customer Registration',
                    'type': 'item',
                    'url': '/crm/customerList'
                },
                {
                    'id': 'jobNew',
                    'title': 'Job Registration',
                    'type': 'item',
                    'url': '/crm/jobNew'
                },
                {
                    'id': 'jobView',
                    'title': 'Job View',
                    'type': 'item',
                    'url': '/crm/jobView'

                },
                {
                    'id': 'jobTaskAllocation',
                    'title': 'Job Task Allocation',
                    'type': 'item',
                    'url': '/crm/jobTaskAllocation'

                },
                {
                    'id': 'jobsForCustomerView',
                    'title': 'Customer Wise Jobs',
                    'type': 'item',
                    'url': '/crm/jobsForCustomerView'

                }
            ]
        },
        {
            'id': 'inventory',
            'title': 'Inventory',
            'type': 'collapse',
            'icon': 'store',
            'children': [
                {
                    'id': 'superTradeCategory',
                    'title': 'Super Category',
                    'type': 'item',
                    'url': '/superTradeCategory'
                },
                {
                    'id': 'tradeCategory',
                    'title': 'Trade Category',
                    'type': 'item',
                    'url': '/tradeCategory'
                },
                {
                    'id': 'departmentCategory',
                    'title': 'Department Category',
                    'type': 'item',
                    'url': '/departmentCategory'
                },
                {
                    'id': 'subCategory',
                    'title': 'Sub Category',
                    'type': 'item',
                    'url': '/subCategory'
                },
                {
                    'id': 'rack',
                    'title': 'Rack',
                    'type': 'item',
                    'url': '/rack'
                },
                {
                    'id': 'rackLevel',
                    'title': 'Rack Level',
                    'type': 'item',
                    'url': '/rackLevel'
                },
                {
                    'id': 'rackPosition',
                    'title': 'Rack Position',
                    'type': 'item',
                    'url': '/rackPosition'
                }
                ,
                {
                    'id': 'brand',
                    'title': 'Brand',
                    'type': 'item',
                    'url': '/brand'
                },
                {
                    'id': 'manufacture',
                    'title': 'Manufacturer',
                    'type': 'item',
                    'url': '/manufacture'
                },
                {
                    'id': 'item',
                    'title': 'Item & Service',
                    'type': 'item',
                    'url': '/item'
                },
                {
                    'id': 'item',
                    'title': 'Supplier',
                    'type': 'item',
                    'url': '/supplier'
                }
            ]
        },
        {
            'id': 'hr',
            'title': 'HR',
            'type': 'collapse',
            'icon': 'group',
            'children': [
                {
                    'id': 'create-Employee',
                    'title': 'Employee Registration',
                    'type': 'item',
                    // 'icon'    : 'playlist_add',
                    'url': '/hr/createEmployee'
                },

                {
                    'id': 'sys-setting',
                    'title': 'System Settings',
                    'type': 'item',
                    // 'icon'    : 'list',
                    'url': '/hr/systemSetting'
                }
            ]
        }
        ,
        {
            'id': 'accParent',
            'title': 'Accounting',
            'type': 'collapse',
            'icon': 'account_balance',
            'children': [
                {
                    'id': 'accTransactions',
                    'title': 'Transactions',
                    'type': 'collapse',
                    'icon': 'account_balance',
                    'children': [
                        {
                            'id': 'journalEntry',
                            'title': 'Journal Entry',
                            'type': 'item',
                            // 'icon'    : 'playlist_add',
                            'url': '/account/journalEntry'
                        },
                        {
                            'id': 'billEntries',
                            'title': 'Bill Entries',
                            'type': 'item',
                            // 'icon'    : 'playlist_add',
                            'url': '/account/billEntries'
                        },
                        {
                            'id': 'billPayment',
                            'title': 'Bill Payment',
                            'type': 'item',
                            // 'icon'    : 'playlist_add',
                            'url': '/account/billPayment'
                        },
                        {
                            'id': 'normalPayment',
                            'title': 'Normal Payment',
                            'type': 'item',
                            // 'icon'    : 'playlist_add',
                            'url': '/account/normalPayment'
                        },
                        {
                            'id': 'interAccTransfer',
                            'title': 'Inter Account Transfer',
                            'type': 'item',
                            // 'icon'    : 'playlist_add',
                            'url': '/account/interAccTransfer'
                        },
                        {
                            'id': 'bankDeposit',
                            'title': 'Bank Deposit',
                            'type': 'item',
                            'url': '/account/bankDeposit'
                        },
                        {
                            'id': 'bankReconciloation',
                            'title': 'Bank Reconciliation',
                            'type': 'item',
                            'url': '/account/bankReconsilation'
                        },
                        {
                            'id': 'cashTransaction',
                            'title': 'Cash Transaction',
                            'type': 'item',
                            'url': '/account/cashTransaction'
                        },
                        {
                            'id': 'cheque-book',
                            'title': 'Cheque Book',
                            'type': 'item',
                            // 'icon'    : 'playlist_add',
                            'url': '/account/chequeBook'
                        },
                        {
                            'id': 'pettyCashReimbursment',
                            'title': 'Petty Cash Reimbursement',
                            'type': 'item',
                            'url': '/account/pettyCashReimbursment'
                        },
                        {
                            'id': 'pettyCashPayment',
                            'title': 'Petty Cash Payment',
                            'type': 'item',
                            'url': '/account/pettyCashPayment'
                        }
                    ]
                },
                {
                    'id': 'accMasterData',
                    'title': 'Master Data',
                    'type': 'collapse',
                    'icon': 'account_balance',
                    'children': [
                        {
                            'id': 'ledger-account',
                            'title': 'Ledger Account',
                            'type': 'item',
                            // 'icon'    : 'playlist_add',
                            'url': '/account/ledger'
                        },
                        {
                            'id': 'openingBalance',
                            'title': 'Opening Balance',
                            'type': 'item',
                            'url': '/account/openingBalance'
                        },
                        {
                            'id': 'account-Category',
                            'title': 'Account Category',
                            'type': 'item',
                            // 'icon'    : 'playlist_add',
                            'url': '/account/accountCategory'
                        },
                        {
                            'id': 'main-account',
                            'title': 'Main Account',
                            'type': 'item',
                            // 'icon'    : 'playlist_add',
                            'url': '/account/main'
                        },
                        {
                            'id': 'account-Bank',
                            'title': 'Bank',
                            'type': 'item',
                            // 'icon'    : 'playlist_add',
                            'url': '/account/bank'
                        },
                        {
                            'id': 'pettyCashCategory',
                            'title': 'Petty Cash Category',
                            'type': 'item',
                            'url': '/account/pettyCashCategory'
                        },
                        {
                            'id': 'pettyCashBook',
                            'title': 'Petty Cash Books',
                            'type': 'item',
                            'url': '/account/pettyCashBook'
                        },
                        {
                            'id': 'cashBookReport',
                            'title': 'Cash Book',
                            'type': 'item',
                            'url': '/accountingReports/cashBook'
                        }
                    ]
                }
                ,
                {
                    'id': 'accGeneralReport',
                    'title': 'General Report',
                    'type': 'collapse',
                    'icon': 'account_balance',
                    'children': [
                        {
                            'id': 'ledgerReport',
                            'title': 'ledger Report',
                            'type': 'item',
                            // 'icon'    : 'playlist_add',
                            'url': '/accountingReports/LedgerReport'
                        },
                        {
                            'id': 'trailBalance',
                            'title': 'Trail Balance',
                            'type': 'item',
                            // 'icon'    : 'playlist_add',
                            'url': '/accountingReports/trailBalance'
                        },
                        {
                            'id': 'pettyCashReport',
                            'title': 'Pettycash Report',
                            'type': 'item',
                            'url': '/accountingReports/pettyCashReport'
                        },
                        {
                            'id': 'journalEntryReport',
                            'title': 'Journal Entry Report',
                            'type': 'item',
                            // 'icon'    : 'playlist_add',
                            'url': '/accountingReports/JournalEntryReport'
                        }
                    ]
                }
                ,
                {
                    'id': 'accMasterReport',
                    'title': 'Master Reports',
                    'type': 'collapse',
                    'icon': 'account_balance',
                    'children': [
                        {
                            'id': 'profitAndSaleReport',
                            'title': 'Profit & Loss Report',
                            'type': 'item',
                            'url': '/accountingReports/profitAndSaleReport'
                        },
                    ]
                }
            ]
        }
        ,

        {
            'id': 'report',
            'title': 'Report',
            'type': 'collapse',
            'icon': 'insert_drive_file',
            'children': [
                {
                    'id': 'customerList',
                    'title': 'Customer List',
                    'type': 'item',
                    // 'icon'    : 'playlist_add',
                    'url': '/customerList'
                },
                {
                    'id': 'brokerList',
                    'title': 'Broker List',
                    'type': 'item',
                    // 'icon'    : 'playlist_add',
                    'url': '/brokerList'
                }
                ,
                {
                    'id': 'employeeWiseTask',
                    'title': 'Employee Wise Task',
                    'type': 'item',
                    // 'icon'    : 'playlist_add',
                    'url': '/employeeWiseTask'
                }

            ]
        }
    ];


// WEBPACK FOOTER //
// ./src/fuse-configs/fuseSupervisorNavigationConfig.js